export default __webpack_public_path__ + "static/media/Amsterdam-UMC.cbb7cf2e.png";